import { BloqueioRodoviario, Cidade, TrechoRodoviario } from "../../index";

export class BloqueioTrechoRodoviario {
    constructor(etapa: Cidade, ordem: number, idTrecho: number, trechoDeRetorno: boolean = false) {
        this.Etapa = etapa;
        this.Etapa.display_field = this.Etapa.Nome + " / " + this.Etapa.Estado.Nome;
        this.Ordem = ordem;
        this.TrechoRodoviarioId = idTrecho;
        this.TrechoDeRetorno = trechoDeRetorno;
    }
    Id: number = 0;
    BloqueioRodoviario: BloqueioRodoviario;
    BloqueioRodoviarioId: number;
    Etapa: Cidade;
    HoraPartida: string;
    HoraChegada: string;
    Ordem: number;
    LocalEmbarque: string;
    TrechoRodoviario: TrechoRodoviario;
    TrechoRodoviarioId: number;
    TrechoDeRetorno: boolean = false;
}
